module.exports = __webpack_public_path__ + "img/51626510_L.ceb34a8b.png";